import React from "react";
import { NavLink } from "react-router-dom";

import classes from "./NavigationItem.module.scss";

const navigationItem = (props) => {
  return (
    <NavLink
      activeClassName={classes.selected}
      className={[classes["nav-link"], "mt-5 ml-5"].join(" ")}
      to={props.link}
      exact={props.exact}
    >
      <div
        className={[
          classes["nav-link-item"],
          "is-size-body-1 bold",
          "px-4 py-1",
        ].join(" ")}
      >
        {props.children}
      </div>
    </NavLink>
  );
};

export default navigationItem;
